import React, { useState, useEffect, useReducer } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { EMAIL_STATUS_ACTIVE, EMAIL_STATUS_INACTIVE } from '../../../constants/UiBuilderConst';

const EmailSelector = (props) => {
  const { onValueChange, value, onEmailStatusChange, isActive, error, maxLength } = props;

  const [statusValue, setStatusValue] = useState(
    isActive ? EMAIL_STATUS_ACTIVE : EMAIL_STATUS_INACTIVE,
  );

  useEffect(() => {
    setStatusValue(isActive ? EMAIL_STATUS_ACTIVE : EMAIL_STATUS_INACTIVE);
  }, [isActive]);

  useEffect(() => {
    onEmailStatusChange(statusValue === EMAIL_STATUS_ACTIVE);
  }, [statusValue]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    email: {
      value: '',
      fieldName: 'Email Address',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    const currFields = { ...formData };
    currFields.email.value = value;
    formData.email.validations = isActive ? ['required', 'validEmail'] : [];
    if (error) {
      currFields.email.errors =
        value?.length < 1
          ? { required: `${currFields.email.fieldName} is required` }
          : {
              required: null,
              htmlError: null,
              validEmail: 'Invalid email format',
            };
    }
    setFormData(currFields);
  }, [value, error]);

  useEffect(() => {
    onValueChange(formData.email.value);
  }, [formData.email.value]);

  const onStatusChange = (e) => {
    formData.email.validations =
      e.target.value === EMAIL_STATUS_ACTIVE ? ['required', 'validEmail'] : [];
    setStatusValue(e.target.value);
    const email = { ...formData.email };
    email.validations = e.target.value === EMAIL_STATUS_ACTIVE ? ['required', 'validEmail'] : [];
    setFormData({ email });
  };

  return (
    <>
      <div className='col-md-12 redirect-selector mb-3'>
        <div className='row align-items-center mb-2 mt-3'>
          <div className='col-md-4 title'>Email</div>
          <div className='col-md-8'>
            <RadioGroup
              row
              aria-label='statusValue'
              onChange={onStatusChange}
              value={statusValue}
              className='document-type'
              name='row-radio-buttons-group'
            >
              <FormControlLabel
                value={EMAIL_STATUS_ACTIVE}
                control={<Radio color='primary' />}
                label='Active'
                className='me-5'
              />
              <FormControlLabel
                value={EMAIL_STATUS_INACTIVE}
                control={<Radio color='primary' />}
                label='Inactive'
              />
            </RadioGroup>
          </div>
        </div>
        {statusValue === EMAIL_STATUS_ACTIVE && (
          <div className='col-md-10'>
            <CustomTextField
              item={formData.email}
              handleInputChange={(e) => {
                setFormData({ email: e });
              }}
              maxLength={maxLength}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default EmailSelector;
